"use client";

import { ReactNode, useContext } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";

export const RecommendationClickLogger = ({
  children,
  clickedResourcePath,
  clickedResourceType,
  recommendationFlag,
}: {
  children: ReactNode;
  clickedResourcePath: string;
  clickedResourceType:
    | "calculator"
    | "video"
    | "tutorial"
    | "fast_question"
    | "clinical_case"
    | "publication"
    | "vademecum";
  recommendationFlag?: string;
}) => {
  const { logView } = useContext(ResourceContext);
  const handleClick = () => {
    logEvent("context_resource_click", logView, {
      clicked_resource_path: clickedResourcePath,
      clicked_resource_type: clickedResourceType,
      recommendation_flag: recommendationFlag,
    });
  };

  return (
    <div onClickCapture={handleClick} className="contents">
      {children}
    </div>
  );
};
